export const build = {"tag":"v1.0.5","hash":"5f4d3353","time":"261009.0722"}